var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollableContentWidth",staticClass:"ll-scrollable-block_wrap",class:{
    bottom: _vm.bottom,
    transparent: _vm.transparent,
    'flex-center': _vm.isComingSoon || _vm.flexCenter,
    'flex-start': _vm.flexStart,
    'has-bg-image': _vm.bgImage,
  },style:(_vm.bgImage ? {
    '--bg-image': 'url(' + _vm.bgImage + ')',
    '--bg-opacity': _vm.bgImageOpacity !== undefined ? _vm.bgImageOpacity : 1,
  } : {})},[(_vm.title && !_vm.isComingSoon)?_c('div',{staticClass:"title-wrap"},[_c('WsText001',{attrs:{"h2":"","bold":"","is-ellipsis2":_vm.isEllipsis2}},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),(_vm.subTitle)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.subTitle))+" ")]):_vm._e(),_vm._t("title"),(_vm.fixedButton)?_c('div',{staticClass:"fixed-button",class:{'no-fixed':_vm.noFixed}},[_vm._t("fixed-button")],2):_vm._e()],2):_vm._e(),_vm._t("sub-title"),(!_vm.isComingSoon)?_vm._t("default"):_c('LlEmptyPic',{attrs:{"image":require('@/assets/image/img-empty/Blue-comingsoon.png'),"big-title":"Coming Soon"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }